import { accessor } from '@/store'

import router from './instance'

router.beforeEach((to, from, next) => {
  const isLogin = accessor.member.isLogin
  const needLogin = to.meta?.login ?? false

  if (needLogin && !isLogin) {
    // 与正常的逻辑不同，没登录跳去404
    next({ path: '/404', replace: true })
    return
  }

  if (isLogin && accessor.member.id === null) {
    accessor.member.loadInfo()
  }

  next()
})
